{
  "id": "sword-training",
  "title": "师徒切磋",
  "background": "env-memory-road-bg",
  "music": "sparring",
  "ambience": ["road-dust"],
  "party": [
    { "id": "jiang-zichao", "name": "江子潮", "hp": 60, "sp": 12, "speed": 7, "attack": 10, "defense": 4, "sprite": "battle-jiang-zichao", "actions": ["attack", "hunter-thrust", "guard", "observe"] }
  ],
  "enemies": [
    { "id": "zhao-chengbo", "name": "赵呈博", "hp": 200, "sp": 99, "speed": 9, "attack": 14, "defense": 8, "sprite": "battle-zhao-chengbo", "actions": ["tutor-probe", "tutor-feint", "tutor-strike", "tutor-rest"], "ai": "tutor" }
  ],
  "actions": [
    { "id": "attack", "name": "普通攻击", "kind": "attack", "spCost": 0, "power": 1.0, "hitChance": 0.85, "anim": "attack", "fx": "slash-arc", "sfx": "sword-swing", "description": "平平常常的一剑。握得还不算稳，但总归是剑。" },
    { "id": "hunter-thrust", "name": "猎手直刺", "kind": "skill", "spCost": 4, "power": 1.6, "hitChance": 0.75, "anim": "skill", "fx": "hit-spark", "sfx": "sword-swing", "hint": "技力 4", "description": "压低身子，直取一点。赵呈博把江子潮追猎时的突进改成了剑招。" },
    { "id": "guard", "name": "防御", "kind": "guard", "spCost": -2, "power": 0.5, "hitChance": 1, "anim": "guard", "sfx": "sword-parry", "hint": "技力 +2", "description": "举剑护身：直到下一次行动前，受到的伤害减半，并回复 2 点技力。" },
    { "id": "observe", "name": "观察", "kind": "observe", "spCost": 0, "power": 0, "hitChance": 1, "anim": "observe", "hint": "不耗回合", "description": "凝神细看，看出老师下一手的意图。不消耗本回合的行动。" },
    { "id": "tutor-probe", "name": "试探一剑", "kind": "attack", "spCost": 0, "power": 0.6, "hitChance": 0.9, "anim": "attack", "fx": "slash-arc", "sfx": "sword-swing", "description": "轻描淡写的一剑，只为看清徒弟的架势。" },
    { "id": "tutor-feint", "name": "虚晃", "kind": "attack", "spCost": 0, "power": 0, "hitChance": 1, "anim": "attack", "sfx": "sword-swing", "effect": "feint", "description": "剑势起了一半便收，不伤人，只吓人。" },
    { "id": "tutor-strike", "name": "真剑一击", "kind": "attack", "spCost": 0, "power": 1.4, "hitChance": 0.95, "anim": "skill", "fx": "hit-spark", "sfx": "sword-hit", "description": "不留手的一剑——当然，老师说的“不留手”。" },
    { "id": "tutor-rest", "name": "收势", "kind": "guard", "spCost": 0, "power": 1, "hitChance": 1, "anim": "praise", "effect": "rest", "targetSp": 2, "description": "老师收剑而立，让徒弟喘口气。" }
  ],
  "ai": [
    {
      "id": "tutor",
      "pattern": ["probe", "feint", "strike", "praise", "strike"],
      "moves": {
        "probe": { "action": "tutor-probe", "label": "试探", "comment": "看清楚了？我只是在试你。" },
        "feint": { "action": "tutor-feint", "label": "虚招", "comment": "这一下是假的，别被吓着。" },
        "strike": { "action": "tutor-strike", "label": "真剑", "comment": "下一剑是真的，护住要害。" },
        "praise": { "action": "tutor-rest", "label": "收势", "comment": "我要歇一歇，你尽管来。" }
      }
    }
  ],
  "rules": { "minRounds": 3, "lowHpRatio": 0.25, "guardDamageMul": 0.5, "observeIsFree": true, "variance": 2, "enemiesNeverKill": true },
  "end": { "maxRounds": 5, "goal": "useSkill", "goalCount": 1 },
  "script": [
    { "on": "start", "dialogue": "sword.start" },
    { "on": "round", "round": 1, "dialogue": "sword.round1" },
    { "on": "round", "round": 2, "dialogue": "sword.round2" },
    { "on": "round", "round": 3, "dialogue": "sword.round3" },
    { "on": "round", "round": 4, "dialogue": "sword.round4" },
    { "on": "round", "round": 5, "dialogue": "sword.round5" },
    { "on": "playerGuard", "dialogue": "sword.guard" },
    { "on": "playerSkill", "dialogue": "sword.skill" },
    { "on": "playerSkillMiss", "dialogue": "sword.skill-miss" },
    { "on": "playerHit", "dialogue": "sword.hit" },
    { "on": "playerMiss", "dialogue": "sword.miss" },
    { "on": "playerLowHp", "dialogue": "sword.lowhp" },
    { "on": "end", "outcome": "goal", "dialogue": "sword.end-goal" },
    { "on": "end", "outcome": "rounds", "dialogue": "sword.end-rounds" },
    { "on": "end", "outcome": "downed", "dialogue": "sword.end-downed" }
  ],
  "dialogues": [
    { "id": "sword.start", "start": "n0", "nodes": [
      { "id": "n0", "text": "路旁的驿亭下，尘土被日头晒成了金色。赵呈博放下行囊，抽出佩剑。", "next": "n1" },
      { "id": "n1", "speaker": "zhao-chengbo", "text": "子潮，把剑拿稳。今日不比输赢，只教你一招。", "next": "n2" },
      { "id": "n2", "speaker": "jiang-zichao", "text": "老师，我这剑……是这样握的吗？", "next": "n3" },
      { "id": "n3", "speaker": "zhao-chengbo", "text": "手再往下一点。好。你打猎时怎样盯住猎物，便怎样盯住我的剑尖。" }
    ] },
    { "id": "sword.round1", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "先试试你的架势。来。" }
    ] },
    { "id": "sword.round2", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "剑不是弓，别只顾着瞄。看好我这一下——" }
    ] },
    { "id": "sword.round3", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "好，这一剑我不留手了。稳住。" }
    ] },
    { "id": "sword.round4", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "不错。喘口气，再来。" }
    ] },
    { "id": "sword.round5", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "最后一回合。把学到的都使出来。" }
    ] },
    { "id": "sword.guard", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "对，先护住自己。猎人若是伤了，山就白爬了。" }
    ] },
    { "id": "sword.skill", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "就是这样！腰要沉，剑随身走。这一招叫「猎手直刺」，记住了。", "next": "n1" },
      { "id": "n1", "speaker": "jiang-zichao", "text": "猎手直刺……我记住了！" }
    ] },
    { "id": "sword.skill-miss", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "腰沉下去了，可惜刺偏了——再来。", "next": "n1" },
      { "id": "n1", "speaker": "jiang-zichao", "text": "……是！" }
    ] },
    { "id": "sword.hit", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "疼吗？疼就记住剑是从哪里来的。" }
    ] },
    { "id": "sword.miss", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "刺空了。你追兔子的时候也这么急？", "next": "n1" },
      { "id": "n1", "speaker": "jiang-zichao", "text": "……兔子不会拿剑。" }
    ] },
    { "id": "sword.lowhp", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "够了，今日到此为止。你还站得住，这就比许多人强了。" }
    ] },
    { "id": "sword.end-goal", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "好，剑术算是粗通了。等到了南陆，这一招或许用得上。", "next": "n1" },
      { "id": "n1", "speaker": "jiang-zichao", "text": "多谢老师！", "next": "n2" },
      { "id": "n2", "speaker": "zhao-chengbo", "text": "收剑吧。天热，我们赶路。" }
    ] },
    { "id": "sword.end-rounds", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "日头偏西了，收剑吧。招式没使出来不要紧，路还长，明日再练。", "next": "n1" },
      { "id": "n1", "speaker": "jiang-zichao", "text": "是，老师。" }
    ] },
    { "id": "sword.end-downed", "start": "n0", "nodes": [
      { "id": "n0", "speaker": "zhao-chengbo", "text": "回去多想想我的剑是怎么来的。剑术不是一日的功夫。", "next": "n1" },
      { "id": "n1", "speaker": "jiang-zichao", "text": "……是，老师。" }
    ] }
  ],
  "sprites": {
    "jiang-zichao": {
      "texture": "battle-jiang-zichao",
      "frameW": 80, "frameH": 64, "facing": "right",
      "anims": { "idle": { "frames": 4, "fps": 6, "loop": true }, "attack": { "frames": 6, "fps": 12 }, "skill": { "frames": 8, "fps": 12 }, "guard": { "frames": 2, "fps": 8 }, "hit": { "frames": 3, "fps": 12 }, "observe": { "frames": 2, "fps": 6 } },
      "dev": { "robe": "#8a6a3a", "sash": "#2b3a5c", "skin": "#d9a878", "hair": "#2a1c14", "blade": "#c9c9d1" }
    },
    "zhao-chengbo": {
      "texture": "battle-zhao-chengbo",
      "frameW": 80, "frameH": 64, "facing": "left",
      "anims": { "idle": { "frames": 4, "fps": 6, "loop": true }, "attack": { "frames": 6, "fps": 12 }, "skill": { "frames": 4, "fps": 10, "source": "parry" }, "guard": { "frames": 2, "fps": 8 }, "hit": { "frames": 2, "fps": 8, "source": "praise" }, "praise": { "frames": 2, "fps": 6 } },
      "dev": { "robe": "#5a6a86", "sash": "#c9b89a", "skin": "#f0d6bd", "hair": "#e8e2d6", "beard": "#e8e2d6", "blade": "#d8d8e0" }
    }
  }
}
